import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom'

import '../Dashboard.css';
import classes from "../Referral/Referral.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

function Referral() {
  const [info, setInfo] = useState([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const config = {
        params: {
            uid: 1,
            pname: 'wesharez'
        },
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }

    useEffect(() => {
        axios.post(`https://wesharez.com/api/user/info.php`, null, config)
        .then(res => {
          setInfo(res.data);
          // console.log(res.data);
        }).catch(err => {
            console.log(err);
        })
    }, [])

    return (
      <div className="container_wrapper">
        <Header />
        <div className={`${styles.main} main`}>
          <Sidebar active="referral" />
          <div className={styles.main_content}>
            <div className={styles.content_body}>
              <div className={`${classes.title} mb-4`}>
                <h5><i className="fa-solid fa-link"></i> Referral Program</h5>
              </div>
              <div className={`${styles.card} mb-5`}>
                <div className="card-body">
                  <section className="p-0">
                    <p className={classes.desc}>Invite a friend Using your refer link and get £2 bonus.</p>
                  </section>
                  <section className="mb-4">
                    <Link to={false}>
                      <button type="button" className="btn btn-light ">withdraw</button>
                    </Link>
                  </section>
                  <section>
                    <div className="row mt-3 mb-4">
                      <div className={classes.refrred}>
                        <div>
                          <h6 className="text-uppercase">Refrred Friends</h6>
                          <h3>{info.refrred}</h3>
                        </div>
                      </div>
                      <div className={classes.balance}>
                        <div>
                          <h6 className="text-uppercase">Referral Balance</h6>
                          <h3>£{info.ref_bonus}</h3>
                        </div>
                      </div>
                    </div>
                  </section>
                <section className="mb-2">
                  <h6 className="mb-3">Share this unique URL with your friends:</h6>
                  <div className="input-group d-flex">
                    <input className={`${classes.refCode} float-center form-control mr-2`} type="text" value={`https://wesharez.com/register?ref=${info.refcode}`} size="40" id="myInput" readOnly={true} />
                    <button className={`${classes.copyBtn} btn btn-danger legitRipple`}>Copy <span>to Clipboard</span></button>
                  </div>
                </section>
                <section>
                  <a href={`https://twitter.com/share?url=https://wesharez.com/register?ref=${info.refcode}`} target="_blank" rel="noreferrer" className={`${classes.share_btn} ${classes.twitter}`}>
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                  <a href={`https://www.linkedin.com/shareArticle?url=https://wesharez.com/register?ref=${info.refcode}`} target="_blank" rel="noreferrer" className={`${classes.share_btn} ${classes.linkedin}`}>
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                  <a href={`mailto:?subject=Create Wesharez Account&body=https://wesharez.com/register?ref=${info.refcode}`} target="_blank" rel="noreferrer" className={`${classes.share_btn} ${classes.email}`}>
                    <i className="fa fa-envelope"></i>
                  </a>
                </section>
                <hr />
                <section>
                  <div className={`${classes.history} col col-6 col-sm-4 col-lg-4`}>
                    <h5>Withdrawals</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Method</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </section>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
}

export default Referral;